<template>
  <div class="advisor-form">
    <Header class="" />
    <h2 class="margin-top25" />
    <b-overlay :show="show" rounded="sm">
      <form-wizard
        color="#366ce3"
        :title="$t('AdvisorForm.Register_advisor')"
        :subtitle="$t('AdvisorForm.Complete_your_account')"
        shape="square"
        :finish-button-text="$t('common.Submit')"
        :next-button-text="$t('common.Next')"
        :back-button-text="$t('common.Previous')"
        class="mb-3 pt-1"
        @on-complete="formSubmitted"
      >
        <!-- Advisor details tab -->
        <tab-content
          :title="$t('AdvisorForm.Advisor_Details')"
          icon="feather icon-file-text"
          :before-change="validationForm"
        >
          <validation-observer ref="accountRules" tag="form">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">{{ $t("AdvisorForm.Advisor_Details") }}</h5>
                <small class="text-muted"
                  >{{ $t("AdvisorForm.Ente_Advisor_Details") }}
                </small>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Full_Name')"
                  label-for="Fomraml_name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="username"
                    rules="required"
                  >
                    <b-form-input
                      id="Fomraml_name"
                      v-model="createAdvisorProfile.name"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('AdvisorForm.Full_Name')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Email')"
                  label-for="email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="createAdvisorProfile.emailValue"
                      type="email"
                      :state="errors.length > 0 ? false : null"
                      placeholder="john.doe@email.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Phone_Number')"
                  label-for="Phone"
                >
                  <validation-provider name="phone" rules="required">
                    <VuePhoneNumberInput
                      v-model="phoneNumber"
                      color="#ea5455"
                      error-color="#ea5455"
                      @update="onUpdate"
                      :translations="
                        $store.state.locale.locale == 'ar'
                          ? translationsArabic
                          : translations
                      "
                    />

                    <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                    <small v-if="!isValidNumber" class="text-danger">{{
                      $t("common.phone_Invalid")
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="owner_type"
                  rules="required"
                >
                  <b-form-group :state="errors.length > 0 ? false : null">
                    <label class="required" label-for="owner_type"
                      >{{ $t("AdvisorForm.Owner_Type") }}
                    </label>

                    <v-select
                      id="owner_type"
                      v-model="createAdvisorProfile.ownerType"
                      :options="
                        $store.state.locale.locale == 'ar'
                          ? OwnerTypeOptionArabic
                          : OwnerTypeOption
                      "
                      :selectable="
                        (option) => !option.value.includes('nothing_selected')
                      "
                      label="text"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
                v-if="createAdvisorProfile.ownerType.value == 'individual'"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Gender"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('AdvisorForm.Gender')"
                    label-for="Gender"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      id="Gender"
                      v-model="createAdvisorProfile.selectedGender"
                      :options="
                        $store.state.locale.locale == 'ar'
                          ? createAdvisorProfile.GenderOptionArabic
                          : createAdvisorProfile.GenderOption
                      "
                      :selectable="
                        (option) => !option.value.includes('nothing_selected')
                      "
                      label="text"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <!-- Advisor Information tab -->
        <tab-content
          :title="$t('AdvisorForm.Advisor_Info')"
          icon="feather icon-user"
          :before-change="validationFormInfo"
        >
          <validation-observer ref="infoRules" tag="form">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">{{ $t("AdvisorForm.Advisor_Info") }}</h5>
                <small class="text-muted">{{
                  $t("AdvisorForm.Enter_Advisor_Info")
                }}</small>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Designation')"
                  label-for="designation"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="designation"
                    rules="required"
                  >
                    <b-form-input
                      id="designation"
                      v-model="createAdvisorProfile.designation"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('AdvisorForm.Designation')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Industry"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('AdvisorForm.industries_service_belong')"
                    label-for="Industry"
                    :state="errors.length > 0 ? false : null"
                  >
                    <div id="app">
                      <treeselect
                        v-model="createAdvisorProfile.selectedIndustry"
                        :multiple="true"
                        :placeholder="$t('common.Select')"
                        :options="industries"
                        @input="handeTreeSelect"
                        :normalizer="
                          $store.state.locale.locale == 'ar'
                            ? normalizerArabic
                            : normalizer
                        "
                      />
                    </div>
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="SkiSkillsIDlls"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('AdvisorForm.Your_Skills')"
                    label-for="SkillsID"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      id="SkillsID"
                      v-model="createAdvisorProfile.selectedSkills"
                      :options="skills"
                      :selectable="
                        () =>
                          createAdvisorProfile.selectedSkills.length <
                          `${$maxSkillsUser}`
                      "
                      multiple
                      label="text"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Country"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('AdvisorForm.Country')"
                    label-for="Country"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      id="Country"
                      v-model="createAdvisorProfile.selectedCountry"
                      multiple
                      :options="countries"
                      :selectable="
                        (option) => !option.value.includes('nothing_selected')
                      "
                      label="text"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Brief_overview_yourself')"
                  label-for="Highlights"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Highlights"
                    :rules="`required|max:${$maxHighlightsUser}`"
                  >
                    <b-form-textarea
                      id="Highlights"
                      v-model="createAdvisorProfile.Highlights"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('AdvisorForm.Brief_overview_yourself')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.description_yourself')"
                  label-for="description"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="createAdvisorProfile.description"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('AdvisorForm.description_yourself')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.description_Previous_Project')"
                  label-for="previousProject"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="previousProject"
                    rules="required"
                  >
                    <b-form-textarea
                      id="previousProject"
                      v-model="createAdvisorProfile.previousProject"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="
                        $t('AdvisorForm.description_Previous_Project')
                      "
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <!-- Experiences  tab-->
        <tab-content
          :title="$t('AdvisorForm.Advisor_Experience')"
          icon="feather icon-tag"
          :before-change="validationFormAddress"
        >
          <validation-observer ref="addressRules" tag="form">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">{{ $t("AdvisorForm.About_you") }}</h5>
                <small class="text-muted">{{
                  $t("AdvisorForm.Enter_Language_Experiences")
                }}</small>
              </b-col>
              <b-col md="12">
                <b-form-group label="" label-for="language">
                  <validation-provider
                    #default="{ errors }"
                    name="language"
                    rules=""
                  >
                    <form-repeater-basic :items="items" />
                    <!-- <b-form-textarea
                    id="description"
                    v-model="createCompanyProfile.description"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Descripe your company"
                  /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="" label-for="Experience">
                  <validation-provider
                    #default="{ errors }"
                    name="Experience"
                    rules=""
                  >
                    <Experience :experiences="experiences" />
                    <!-- <b-form-textarea
                    id="description"
                    v-model="createCompanyProfile.description"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Descripe your company"
                  /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <!-- Social  tab-->
        <tab-content
          :title="$t('AdvisorForm.Social_Links')"
          icon="feather icon-link"
          :before-change="validationFormSocial"
        >
          <validation-observer ref="socialRules" tag="form">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">{{ $t("AdvisorForm.Social_Links") }}</h5>
                <small class="text-muted">{{
                  $t("AdvisorForm.Enter_Social_Links")
                }}</small>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Facebook')"
                  label-for="facebook"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Facebook"
                    rules="url"
                  >
                    <b-form-input
                      id="facebook"
                      v-model="createAdvisorProfile.facebookUrl"
                      :state="errors.length > 0 ? false : null"
                      placeholder="https://facebook.com/abc"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Twitter')"
                  label-for="twitter"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Twitter"
                    rules="url"
                  >
                    <b-form-input
                      id="twitter"
                      v-model="createAdvisorProfile.twitterUrl"
                      :state="errors.length > 0 ? false : null"
                      placeholder="https://twitter.com/abc"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.LinkedIn')"
                  label-for="linked-in"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="LinkedIn"
                    rules="url"
                  >
                    <b-form-input
                      id="linked-in"
                      v-model="createAdvisorProfile.linkedinUrl"
                      :state="errors.length > 0 ? false : null"
                      placeholder="https://linkedin.com/abc"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('AdvisorForm.Website')"
                  label-for="Other"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Other"
                    rules="url"
                  >
                    <b-form-input
                      id="Other"
                      v-model="createAdvisorProfile.OtherUrl"
                      :state="errors.length > 0 ? false : null"
                      placeholder="https://other.com/abc"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
        <!-- files -->
        <tab-content
          :title="$t('AdvisorForm.Attachment')"
          icon="feather icon-file-plus"
          :before-change="validationFormFiles"
        >
          <validation-observer ref="attachmentRules" tag="form">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">{{ $t("AdvisorForm.Attachment") }}</h5>
                <small class="text-muted">{{
                  $t("AdvisorForm.Upload_your_files")
                }}</small>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Personal Photo"
                    :rules="`required|size:${$sizeFilesUser}`"
                  >
                    <label for="PersonalPhoto"
                      >{{ $t("AdvisorForm.Upload_Personal_Photo") }}
                    </label>
                    <b-form-file
                      id="PersonalPhoto"
                      v-model="createAdvisorProfile.PersonalPhoto"
                      required
                      accept="image/jpeg, image/png, image/gif"
                      :state="errors.length > 0 ? false : null"
                      drop-placeholder="Drop file here..."
                      :multiple="false"
                      :placeholder="$t('common.Choose_file_drop')"
                      :browse-text="$t('common.Browse')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Advisor Prove"
                    :rules="`required|size:${$sizeFilesUser}`"
                  >
                    <label for="Advisor-Prove"
                      >{{ $t("AdvisorForm.Advisor_Prove") }}
                    </label>
                    <b-form-file
                      id="Advisor-Prove"
                      v-model="createAdvisorProfile.AdvisorProve"
                      required
                      accept="image/jpeg, image/png, image/gif"
                      :state="errors.length > 0 ? false : null"
                      drop-placeholder="Drop file here..."
                      :multiple="false"
                      :placeholder="$t('common.Choose_file_drop')"
                      :browse-text="$t('common.Browse')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="certificates"
                    :rules="`size:${$sizeFilesUser}`"
                  >
                    <label for="Advisor-certificates"
                      >{{ $t("AdvisorForm.Upload_certificates") }}
                    </label>
                    <b-form-file
                      id="Advisor-certificates"
                      v-model="createAdvisorProfile.AdvisorCertificates"
                      accept="application/pdf, application/vnd.ms-excel,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('common.Choose_file_drop')"
                      drop-placeholder="Drop file here..."
                      multiple
                      :browse-text="$t('common.Browse')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="relevant docouments"
                    :rules="`size:${$sizeFilesUser}`"
                  >
                    <label for="relevant-Docouments"
                      >{{ $t("AdvisorForm.relevant_Docouments") }}
                    </label>
                    <b-form-file
                      id="relevant-Docouments"
                      v-model="createAdvisorProfile.AdvisorRelevant"
                      accept="application/pdf, application/vnd.ms-excel,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('common.Choose_file_drop')"
                      drop-placeholder="Drop file here..."
                      multiple
                      :browse-text="$t('common.Browse')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-alert
                  v-if="errorMessage"
                  show
                  variant="warning p-1"
                  class="warning"
                  style="color: red"
                  >{{ errorMessage }}</b-alert
                >
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
      </form-wizard>
    </b-overlay>
    <Footer class="company-form-footer" />
  </div>
</template>

<script>
import store from "@/store";
import Header from "@/layouts/landpage/Header.vue";
import Footer from "@/layouts/landpage/Footer.vue";

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormFile,
  BFormGroup,
  BFormInput,
  BAlert,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import Experience from "../form-repeater/ExperiencRepeater.vue";
import FormRepeaterBasic from "../form-repeater/LanguageRepeater.vue";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
// eslint-disable-next-line import/order
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import "../../../layouts/landpage/ValidationFrom.js";

export default {
  components: {
    Header,
    Footer,
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BFormFile,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BAlert,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // eslint-disable-next-line vue/no-unused-components
    BFormDatepicker,
    BFormTextarea,
    FormRepeaterBasic,
    Experience,
    VuePhoneNumberInput,
    Treeselect,
    BOverlay,
  },
  data() {
    return {
      translations: {
        countrySelectorLabel: "Country code",
        countrySelectorError: "Choose a country",
        phoneNumberLabel: "Phone number",
        example: "Exemple :",
      },
      translationsArabic: {
        countrySelectorLabel: "رمز البلد",
        countrySelectorError: "اختر دولة",
        phoneNumberLabel: "رقم الهاتف",
        example: "مثال :",
      },
      show: false,
      errorMessage: "",
      isValidNumber: null,
      phoneNumber: null,
      phoneCode: "",
      experiences: [],
      items: [],
      certificates: [],
      institute: [],
      createAdvisorProfile: {
        selectedContry: "",
        name: "",
        emailValue: "",
        designation: "",
        SelectedphoneCode: "",
        Phone: "",
        ownerType: "",
        previousProject: "",
        selectedGender: "",
        selectedIndustry: [],
        selectedSkills: [],
        Highlights: "",
        description: "",
        selectedCity: "",
        selectedState: "",
        selectedCountry: [],
        otherInfo: "",
        twitterUrl: "",
        facebookUrl: "",
        OtherUrl: "",
        linkedinUrl: "",
        PersonalPhoto: null,
        AdvisorProve: null,
        AdvisorCertificates: [],
        AdvisorRelevant: [],
        GenderOption: [
          { value: "male", text: "Male" },
          { value: "female", text: "Female" },
        ],
        GenderOptionArabic: [
          { value: "male", text: "ذكر" },
          { value: "female", text: "أنثى" },
        ],
      },
      OwnerTypeOption: [
        { value: "individual", text: "Individual" },
        { value: "group", text: "Group" },
      ],
      OwnerTypeOptionArabic: [
        { value: "individual", text: "فرد" },
        { value: "group", text: "مجموعة" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      categories: "profile/getInvestorCategories",
      industries: "profile/getAllIndustries",
      currencies: "currency/getCurrencies",
      countries: "country/getCountries",
      user: "auth/user",
      skills: "profile/getAllSkills",
    }),
  },
  mounted() {
    this.fetchCategories();
    this.fetchIndustries();
    this.fetchCurrencies();
    this.fetchCountries();
    this.fetchSkills();
    this.configValidate();
  },
  created() {
    store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);
    store.commit("appConfig/UPDATE_FOOTER_CONFIG", { type: "hidden" });
    store.commit("appConfig/UPDATE_NAVBAR_CONFIG", { type: "hidden" });
  },
  methods: {
    ...mapActions({
      fetchCategories: "profile/retreiveCategories",
      fetchIndustries: "profile/retreiveIndustries",
      fetchCurrencies: "currency/retreiveCurrencies",
      createAdvisor: "profile/createAdvisor",
      fetchCountries: "country/retreiveCountries",
      fetchSkills: "profile/retreiveSkills",
    }),
    normalizerArabic(node) {
      return {
        id: node.id,
        label: node.arabicName != null ? node.arabicName : node.label,
        children: node.children,
      };
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: node.children,
      };
    },
    handeTreeSelect(data) {
      if (data.length > 6) {
        this.createAdvisorProfile.selectedIndustry.length = 6;
      }
    },

    onUpdate(payload) {
      if (this.phoneNumber == null) {
        this.isValidNumber = true;
      } else {
        this.isValidNumber = payload.isValid;
      }
      this.phoneCode = payload.countryCode;
    },
    retreiveStates(data) {
      this.fetchStates(data);
    },
    pluck(array, key) {
      return array.map((o) => o[key]);
    },
    formSubmitted() {
      this.show = true;
      const formatIndustries = [];
      const formatLanguage = [];
      const formatExperince = [];
      const formatLocation = [];
      const formatSkills = [];
      this.createAdvisorProfile.selectedSkills.forEach((element) => {
        formatSkills.push(element.value);
      });
      if (this.createAdvisorProfile.selectedIndustry) {
        this.createAdvisorProfile.selectedIndustry.forEach((element) => {
          formatIndustries.push(element);
        });
      }
      this.items.forEach((element) => {
        formatLanguage.push({
          name: element.name.text,
          level: element.level,
        });
      });
      this.experiences.forEach((element) => {
        formatExperince.push({
          name: element.name,
          years: element.years,
          company: element.company,
          location: element.country.value,
        });
      });
      this.createAdvisorProfile.selectedCountry.forEach((element) => {
        formatLocation.push(element.value);
      });
      const advisorData = new FormData();
      // eslint-disable-next-line no-underscore-dangle
      advisorData.append("userId", this.user._id);
      advisorData.append("userType", "advisor");
      advisorData.append("fullName", this.createAdvisorProfile.name);
      advisorData.append("emailAddress", this.createAdvisorProfile.emailValue);
      advisorData.append("phoneNumber", this.phoneNumber.replace(/\s/g, ""));
      advisorData.append("phoneCode", this.phoneCode);
      advisorData.append(
        "ownerType",
        this.createAdvisorProfile.ownerType.value
      );
      if (this.createAdvisorProfile.ownerType.value == "individual") {
        advisorData.append(
          "gender",
          this.createAdvisorProfile.selectedGender.value
        );
      }

      advisorData.append("designation", this.createAdvisorProfile.designation);
      advisorData.append(
        "previousProject",
        this.createAdvisorProfile.previousProject
      );
      advisorData.append("industries", JSON.stringify(formatIndustries));
      advisorData.append("highlights", this.createAdvisorProfile.Highlights);
      advisorData.append("description", this.createAdvisorProfile.description);
      advisorData.append("languages", JSON.stringify(formatLanguage));
      advisorData.append("experiences", JSON.stringify(formatExperince));
      advisorData.append("address", JSON.stringify(formatLocation));
      advisorData.append("skills", JSON.stringify(formatSkills));
      if (this.createAdvisorProfile.facebookUrl) {
        advisorData.append(
          "advisorFacebook",
          this.createAdvisorProfile.facebookUrl
        );
      }
      if (this.createAdvisorProfile.twitterUrl) {
        advisorData.append(
          "advisorTwitter",
          this.createAdvisorProfile.twitterUrl
        );
      }
      if (this.createAdvisorProfile.linkedinUrl) {
        advisorData.append(
          "advisorLinkedIn",
          this.createAdvisorProfile.linkedinUrl
        );
      }
      if (this.createAdvisorProfile.OtherUrl) {
        advisorData.append(
          "advisorOtherLinks",
          this.createAdvisorProfile.OtherUrl
        );
      }
      advisorData.append(
        "personalPhoto",
        this.createAdvisorProfile.PersonalPhoto
      );
      advisorData.append(
        "advisorProves",
        this.createAdvisorProfile.AdvisorProve
      );

      if (this.createAdvisorProfile.AdvisorCertificates) {
        for (const i of Object.keys(
          this.createAdvisorProfile.AdvisorCertificates
        )) {
          advisorData.append(
            "certificates",
            this.createAdvisorProfile.AdvisorCertificates[i]
          );
        }
      }

      if (this.createAdvisorProfile.AdvisorRelevant) {
        for (const i of Object.keys(
          this.createAdvisorProfile.AdvisorRelevant
        )) {
          advisorData.append(
            "otherDocuments",
            this.createAdvisorProfile.AdvisorRelevant[i]
          );
        }
      }

      this.createAdvisor(advisorData)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false;
          this.$router.replace("/pages/pricing", () => {
            this.$router.go(0);
          });
          // this.$router.push({ name: "pages-pricing" });
        })
        .catch((error) => {
          this.show = false;
          this.errorMessage = error.response.data.error.message;
        });
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success && this.isValidNumber) {
            resolve(true);
            window.scrollTo(0, 0);
          } else {
            reject();
          }
        });
      });
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then((success) => {
          if (success) {
            resolve(true);
            window.scrollTo(0, 0);
          } else {
            reject();
          }
        });
      });
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then((success) => {
          if (success) {
            resolve(true);
            window.scrollTo(0, 0);
          } else {
            reject();
          }
        });
      });
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then((success) => {
          if (success) {
            resolve(true);
            window.scrollTo(0, 0);
          } else {
            reject();
          }
        });
      });
    },
    validationFormFiles() {
      return new Promise((resolve, reject) => {
        this.$refs.attachmentRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>

<style type="text/css">
[dir] label {
  font-size: 14px;
}
[dir] .form-control {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  font-size: 15px;
}

[dir] .vue-form-wizard .wizard-card-footer .wizard-footer-right .wizard-btn {
  background-color: #366ce3;
  border-color: #2d5dc7;
}

[dir] .vs__selected {
  background-color: #366ce3;
}
</style>
